import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface FilterState {
  searchTearm: string;
}

const initialState: FilterState = {
  searchTearm: '',
};

const filterSlice = createSlice({
  name: `filter`,
  initialState,
  reducers: {
    setSearchTearm: (state, action: PayloadAction<FilterState>) => {
      state.searchTearm = action.payload.searchTearm;
    },
  },
});

export const { setSearchTearm } = filterSlice.actions;
export default filterSlice.reducer;
